<template>
  <v-dialog width="620" v-model="dialog" persistent scrollable>
    <ExistedDialog :state="existedDialog" :id="existedId" @close="closeExisted" />
    <v-card>
      <v-card-title class="blue darken-4 white--text">
        <v-toolbar-title>THÊM KHÁCH HÀNG TIỀM NĂNG</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-6">
        <v-form v-bind="this.$attrs" ref="form">
          <h3 class="pb-6">Thông tin liên lạc</h3>

          <v-text-field label="Tên" v-model="contact.buyerName" outlined hide-details></v-text-field>
          <v-text-field
            label="Điện thoại"
            required
            type="tel"
            v-model="contact.phone"
            :rules="[$rules.required, $rules.phone]"
            outlined
            class="pt-6 required"
          ></v-text-field>
          <v-text-field
            label="Email"
            type="email"
            v-model="contact.email"
            outlined
            :rules="[$rules.email]"
          ></v-text-field>

          <h3>Thông tin học sinh</h3>
          <div>
            <div v-for="(student, index) in students" :key="index">
              <div class="px-0 pt-6">
                <div class="d-flex">
                  <div class="pb-6 d-flex" style="flex-grow: 1">
                    <v-text-field
                      :label="`Tên học sinh ${index + 1}`"
                      v-model="student.name"
                      outlined
                      hide-details
                      style="flex-grow: 1"
                      class="pr-6"
                    ></v-text-field>
                    <v-text-field
                      label="Trường"
                      v-model="student.school"
                      outlined
                      hide-details
                      style="flex-grow: 1"
                      class="pr-6"
                    ></v-text-field>
                  </div>
                  <div class="pb-6 d-flex align-items-center justify-content-end" style="flex-grow: 0">
                    <v-icon @click="removeStudent(index)" color="transparent">mdi-trash-can</v-icon>
                  </div>
                </div>

                <div class="d-flex">
                  <div class="pb-6 d-flex" style="flex-grow: 1">
                    <v-text-field
                      label="Ngày sinh (dd/mm/yyyy)"
                      v-model="student.dob"
                      mask="##/##/####"
                      return-masked-value
                      outlined
                      hide-details
                      style="flex-grow: 1"
                      class="pr-6"
                    ></v-text-field>
                    <v-text-field
                      label="Lớp đang học"
                      v-model="student.class"
                      outlined
                      hide-details
                      style="flex-grow: 1"
                      class="pr-6"
                    ></v-text-field>
                  </div>
                  <div class="pb-6 d-flex align-items-center justify-content-end" style="flex-grow: 0">
                    <v-icon @click="removeStudent(index)">mdi-trash-can</v-icon>
                  </div>
                </div>
              </div>

              <v-divider v-if="index < students.length - 1"></v-divider>
            </div>
            <div class="d-flex justify-space-between pb-6">
              <v-spacer></v-spacer>
              <v-btn outlined color="blue darken-4" @click="addStudent">Thêm</v-btn>
            </div>
          </div>

          <h3 class="pb-6">Thông tin chăm sóc</h3>

          <div v-for="(product, index) in saleInfo.products" :key="product.id">
            <div class="d-flex justify-space-between pb-6">
              <v-select
                :items="getAvailableProducts(index)"
                item-text="name"
                item-value="id"
                v-model="saleInfo.products[index]"
                :label="`Chọn hệ đào tạo quan tâm ${index + 1}`"
                return-object
                outlined
                hide-details
              ></v-select>
              <v-icon class="ml-6" @click="removeProduct(index)">mdi-trash-can</v-icon>
            </div>
          </div>
          <div class="d-flex justify-space-between">
            <v-spacer></v-spacer>
            <v-btn outlined color="blue darken-4" @click="addProduct">Thêm</v-btn>
          </div>
          <v-select
            label="Mức độ quan tâm"
            :items="interestOptions"
            item-text="label"
            item-value="value"
            v-model="saleInfo.interest"
            outlined
            hide-details
            class="py-6"
          ></v-select>
          <v-select
            label="Phân khúc"
            :items="segmentOptions"
            item-text="label"
            item-value="value"
            v-model="saleInfo.segment"
            outlined
            hide-details
          ></v-select>
          <v-text-field label="Nguồn" v-model="saleInfo.origin" outlined hide-details class="py-6"></v-text-field>
          <v-textarea label="Ghi chú" v-model="saleInfo.note" outlined hide-details></v-textarea>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn color="blue darken-4" outlined @click="close">Hủy </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-4" dark @click="submit">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import utils from '@/plugins/utils'
import ExistedDialog from './ExistedDialog.vue'
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    state: Boolean,
    products: Array,
    users: Array,
  },
  components: {
    ExistedDialog,
  },
  watch: {
    state(state) {
      this.dialog = state
      if (!state) this.loading = false
    },
  },
  computed: {
    ...mapGetters('auth', ['user']),
    productOptions() {
      const product = this.products.map((product) => ({
        label: product.name,
        value: product.id,
      }))
      return product
    },
    allProducts() {
      if (!this.products) return []
      return this.products.filter((item) => !this.saleInfo.products.some((product) => product.id === item.id))
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      selectedProduct: null,
      existedDialog: false,
      existedId: '',
      contact: {
        buyerName: '',
        phone: '',
        email: '',
      },
      students: [
        {
          name: '',
          class: '',
          dob: '',
          school: '',
        },
      ],
      saleInfo: {
        products: [{}],
        interest: '',
        segment: '',
        origin: '',
        note: '',
      },

      interestOptions: [
        { label: 'Thấp', value: 'cold' },
        { label: 'Vừa', value: 'warm' },
        { label: 'Cao', value: 'hot' },
      ],
      segmentOptions: [
        { label: 'Phổ thông', value: 'intermediate' },
        { label: 'Cao cấp', value: 'advance' },
      ],
    }
  },
  methods: {
    ...mapActions('lead', ['createLead']),

    close() {
      this.$emit('closeDialog')
      this.$refs.form.resetValidation()
    },
    addStudent() {
      this.students.push({
        name: '',
        class: '',
        dob: '',
        school: '',
      })
    },
    removeStudent(index) {
      this.students.splice(index, 1)
    },
    removeProduct(index) {
      if (this.saleInfo.products.length > 1) {
        this.saleInfo.products.splice(index, 1)
      } else {
        this.$set(this.saleInfo.products, index, {})
      }
    },
    addProduct() {
      this.saleInfo.products.push('')
    },
    getAvailableProducts(index) {
      const currentProductId = this.saleInfo.products[index].id
      return this.products.filter(
        (product) =>
          product.id === currentProductId ||
          !this.saleInfo.products.some((selectedProduct) => selectedProduct.id === product.id)
      )
    },
    async submit() {
      if (this.$refs.form.validate()) {
        this.$loading.active = true

        // Improved function to check if a product is empty
        const isProductEmpty = (product) => {
          return (
            !product || Object.keys(product).length === 0 || !product.id || Object.values(product).every((val) => !val)
          )
        }

        // Filter out empty products
        const filteredProducts = this.saleInfo.products.filter((product) => !isProductEmpty(product))
        this.saleInfo.products = filteredProducts
        let lead = {
          ...this.contact,
          ...this.saleInfo,
          data: { student: this.students },
        }

        const processField = (field) => {
          return this.students
            .map((student) => student[field])
            .filter(Boolean)
            .map((name) => utils.removeUnicode(name).toLowerCase())
            .join(' // ')
        }

        // Additional lead fields processing
        lead.createdByName = this.user.name
        lead.inCharge = this.user.id
        lead.studentNameSearchField = processField('name')
        lead.studentSchoolSearchField = processField('school')
        lead.studentClassSearchField = processField('class')
        // API call to create the lead
        const createLead = await this.createLead({ ...lead })
        this.$loading.active = false

        if (createLead && createLead.message !== 'phone existed') {
          this.$emit('refresh')
          this.resetForm()
          this.close()
        } else if (createLead.message === 'phone existed') {
          this.existedDialog = true
          this.existedId = createLead.id
        } else {
          this.$alert.error('Lỗi tạo khách hàng')
        }
      }
    },
    closeExisted() {
      this.existedDialog = false
    },
    resetForm() {
      this.contact = {
        buyerName: '',
        phone: '',
        email: '',
      }
      this.students = [
        {
          name: '',
          class: '',
          dob: '',
          school: '',
        },
      ]
      this.saleInfo = {
        products: [],
        interest: '',
        segment: '',
        origin: '',
        note: '',
      }
      this.selectedProduct = null
    },
  },
}
</script>

<style>
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 2px !important;
}
</style>
